import {useCookie, useCookieValueCallback} from '@aboutyou/storage';
import {AB_TEST_COOKIES} from './types';

const identityFn = (rawValue: string) => rawValue;
export const useAbTestUserIdCookie = () => {
  return useCookie({
    cookieName: AB_TEST_COOKIES.UserId,
    defaultValue: undefined,
    transformRawValue: identityFn,
    config: {
      expirationInDays: 60,
    },
  });
};

export const useGetAbTestUserId = () => {
  const getCookieValue = useCookieValueCallback({
    cookieName: AB_TEST_COOKIES.UserId,
    defaultValue: undefined,
    transformRawValue: identityFn,
  });
  return getCookieValue;
};
